import { useState, useEffect } from "react";
import StatsCard from "./StatsCard";
import { getStreak, getActivityList, getTodayStats } from "../../dashboard";

const EMPTY_WEEK = Array(7).fill(false);

const StatsCardRow = ({ selectedLanguage, refreshKey = 0 }) => {
    const [streak, setStreak] = useState(null);
    const [activityArray, setActivityArray] = useState(EMPTY_WEEK);
    const [score, setScore] = useState(null);
    const [sentencesToday, setSentencesToday] = useState(null);
    const [practiceMinutes, setPracticeMinutes] = useState(null);

    // Show the loading skeleton only when switching languages. A refreshKey bump
    // (after practicing a sentence) keeps the old values visible until the new
    // ones arrive, so the cards don't flash back to "—".
    useEffect(() => {
        setStreak(null);
        setActivityArray(EMPTY_WEEK);
        setScore(null);
        setSentencesToday(null);
        setPracticeMinutes(null);
    }, [selectedLanguage]);

    useEffect(() => {
        if (!selectedLanguage) return;

        let cancelled = false;

        Promise.allSettled([
            getStreak(selectedLanguage),
            getActivityList(7, selectedLanguage),
            getTodayStats(selectedLanguage),
        ]).then(([streakResult, activityResult, statsResult]) => {
            if (cancelled) return;
            if (streakResult.status === "fulfilled") setStreak(streakResult.value);
            if (activityResult.status === "fulfilled") setActivityArray(activityResult.value);
            if (statsResult.status === "fulfilled") {
                const s = statsResult.value;
                setScore(s.score);
                setSentencesToday(s.sentences_today);
                setPracticeMinutes(s.practice_minutes);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [selectedLanguage, refreshKey]);

    return (
        <div className="grid grid-cols-2 gap-2 md:flex md:gap-4 items-stretch">
            <div className="md:flex-1">
                <StatsCard type="streak" value={streak} activityArray={activityArray} />
            </div>
            <div className="md:flex-1">
                <StatsCard type="score" value={score} />
            </div>
            <div className="md:flex-1">
                <StatsCard type="sentences" value={sentencesToday} />
            </div>
            <div className="md:flex-1">
                <StatsCard type="practice" value={practiceMinutes} />
            </div>
        </div>
    );
};

export default StatsCardRow;
